"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../../hooks");
const useStyles = props => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccTaskManagerSectionCardStyle = (0, _react.useMemo)(() => {
    const ccTaskManagerSectionCard = (0, _css.css)({
      display: 'flex',
      marginBottom: pxToRem(20),
      gap: 12
    });
    const ccTaskManagerSectionCardIcon = (0, _css.css)({
      color: themeColors?.primary.main
    });
    const ccTaskManagerSectionCardTitle = (0, _css.css)({
      fontSize: pxToRem(isMobileView ? 16 : 14),
      fontWeight: 'bold'
    });
    return {
      ccTaskManagerSectionCard,
      ccTaskManagerSectionCardIcon,
      ccTaskManagerSectionCardTitle
    };
  }, [isMobileView, pxToRem, themeColors?.primary.main]);
  return {
    'cc-TaskManager__section-card': ccTaskManagerSectionCardStyle.ccTaskManagerSectionCard,
    'cc-TaskManager__section-card__icon': ccTaskManagerSectionCardStyle.ccTaskManagerSectionCardIcon,
    'cc-TaskManager__section-card__title': ccTaskManagerSectionCardStyle.ccTaskManagerSectionCardTitle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;